'use client'

import { useState } from 'react'
import { cn } from '#app/shared/lib/misc.js'
import { dateToDataTableUTC } from '#app/shared/lib/strings.js'
import { Icon } from '../../icons/Icon.tsx'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../popups/Popover.tsx'
import { DatePicker } from '../DatePicker.tsx'
import {
  type InputSize,
  getOutlineLabelStyles,
  inputSizeOptions,
} from '../Input.tsx'

export type DatePickerProps = {
  label?: string
  date?: Date
  onChange?: (newDate?: Date) => void
  name?: string
  className?: string
  iconClassName?: string
  readOnly?: boolean
  size?: InputSize
  fromYear?: number
  toYear?: number
}
export function DatePickerSelect({
  label = 'Escoge una fecha',
  date,
  onChange,
  className,
  iconClassName,
  readOnly = false,
  size = '55px',
  fromYear,
  toYear,
}: DatePickerProps) {
  const sizeClassName = inputSizeOptions[size]
  const [isOpenState, setOpen] = useState(false)
  const isOpen = readOnly ? false : isOpenState

  const handleChangeDate = (value?: Date) => {
    console.log('🔍 DatePickerSelect - User selected date:', value)
    console.log(
      '🔍 DatePickerSelect - Selected date ISO:',
      value?.toISOString(),
    )
    console.log('🔍 DatePickerSelect - Selected date local:', value?.toString())
    setOpen(false)
    onChange && onChange(value)
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLButtonElement>) {
    if (event.key === 'Enter' || event.key === ' ') {
      setOpen(!isOpenState)
    }
  }

  return (
    <Popover onOpenChange={() => setOpen(!isOpen)} open={isOpen}>
      <PopoverTrigger
        asChild
        className="w-full"
        disabled={readOnly}
        onKeyDown={handleKeyDown}
      >
        <fieldset
          className={cn(
            `
              relative flex h-14 w-full max-w-[300px] cursor-pointer
              items-center justify-start rounded-lg border border-input px-4

              focus:border-2

              hover:border-foreground

              ${isOpen && `border-2 border-foreground`}
            `,
            `
              focus-visible:border-foreground focus-visible:!outline-none

              focus:border-2 focus:border-foreground
            `,
            sizeClassName,
            readOnly && '!cursor-auto !border-input',
            className,
          )}
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex={0}
        >
          <legend
            className={`
              invisible h-[5px] px-1 text-xs

              ${date || isOpen ? 'block' : `hidden`}
            `}
          >
            {label}
          </legend>
          <Icon
            name="basic/calendar"
            className={cn('mr-2 h-4 w-4', iconClassName)}
          />
          <div
            className={getOutlineLabelStyles({
              leftIcon: true,
              value: date,
              open: isOpen,
            })}
          >
            {label}
          </div>
          <div className="z-1 mt-1">{date && dateToDataTableUTC(date)}</div>
        </fieldset>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <DatePicker
          mode="single"
          selected={date}
          onSelect={handleChangeDate}
          initialFocus
          fromYear={fromYear}
          toYear={toYear}
        />
      </PopoverContent>
    </Popover>
  )
}
